import React from "react";

function FpgeeditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fill="#fff"
        d="M10.933 2.893L9.107 1.067a1.333 1.333 0 00-1.774-.047l-6 6c-.215.217-.35.502-.38.807l-.286 2.78a.667.667 0 00.666.727h.06l2.78-.254c.305-.03.59-.164.807-.38l6-6a1.28 1.28 0 00-.047-1.807zm-6.88 6.854l-2 .186.18-2L6 4.213l1.8 1.8-3.747 3.734zM8.667 5.12L6.88 3.333 8.18 2 10 3.82l-1.333 1.3z"
      ></path>
    </svg>
  );
}

export default FpgeeditIcon;